<template>
  <div>
    <nav-title>
      <div slot="rightTool">
        <el-button @click="showUploadDialog" type="primary" v-if="hasAuth('112')">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-cross"></use>
          </svg>
          <span style="margin: 0 5px;">
            添加模板
          </span>
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-picture"></use>
          </svg>
        </el-button>
      </div>
    </nav-title>
    <div class="layout-main">
      <div class="filter">
        <el-input
          class="cl-middle-font-size"
          style="width: 300px; margin: 0 8px 0 0"
          suffix-icon="el-icon-search"
          size="small"
          v-model="query"
          placeholder="请输入模板名称"
        />
        <div class="field">
          <multi-selecter
            :options="typeTags"
            :value.sync="selection"
            label="行业分类"
          />
        </div>
        <div class="field">
          <multi-selecter
            :options="sizeTags"
            :value.sync="selectionSize"
            label="尺寸"
          />
        </div>
      </div>
      <list-row :gutter="24" :width="204" v-loading="loading">
        <list-col v-for="item in list" :key="item.id">
          <div class="item">
            <div class="mask-wrap">
              <div
                class="content"
                v-html="item.filePath"
                @click="previewTemplate(item)"
              ></div>
              <div class="mask-item">
                <div class="button" @click="previewTemplate(item)">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-preview"></use>
                  </svg>
                </div>
                <div class="button" @click="editTemplateMeta(item)" v-if="hasAuth('112')">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-setting"></use>
                  </svg>
                </div>
                <div class="button" @click="editTemplate(item)" v-if="hasAuth('111')">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-edit"></use>
                  </svg>
                </div>
                <div class="button" @click="remove(item.id)" v-if="hasAuth('112')">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-delete"></use>
                  </svg>
                </div>
              </div>
            </div>
            <div class="info">
              <div class="name">{{ item.name }}</div>
              <div class="size">
                {{ item.fileContent.width }}x{{ item.fileContent.height }}
              </div>
            </div>
          </div>
        </list-col>
      </list-row>
      <div class="pagination">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="保存模板"
        class="template-dialog"
        :visible.sync="dialogVisible"
        width="600px"
      >
        <div class="form">
          <el-form
            ref="form"
            label-suffix=":"
            label-width="99px"
            :model="form"
            :rules="rules"
          >
            <el-form-item label="模板名称" prop="name">
              <el-input
                placeholder="请填写模板名称"
                style="width: 200px"
                v-model="form.name"
              ></el-input>
              <span class="template-name-desc"
                >命名时建议带尺寸，如：京东618大促-690*360</span
              >
            </el-form-item>
            <div class="divider-line"></div>
            <el-form-item label="行业分类" prop="tagIds">
              <category-select v-model="form.tagIds" />
            </el-form-item>
            <div class="divider-line"></div>
            <el-form-item label="上传模板" prop="fileContent">
              <upload-svg v-model="form.fileContent" />
            </el-form-item>
          </el-form>
          <p class="template-desc">*上传模板后请预览模板，预览无误再保存</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveTemplateHandler"
            >提 交</el-button
          >
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog class="preview-dialog" title="预览" :visible.sync="preview">
        <div class="content" v-html="previewSvg"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import UploadSvg from 'components/UploadSvg';
import CategorySelect from 'components/CategorySelect';
import { convertJSON } from 'utils/helper';
import { hasAuth } from 'utils/auth';
import NavTitle from 'components/NavTitle';
import MultiSelecter from 'components/MultiSelecter';
import Row from 'components/List/Row';
import Col from 'components/List/Col';
import ListMixins from 'mixins/list';
import _ from 'lodash';

export default {
  name: 'TemplateList',
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'basic',
      selection: [],
      selectionSize: [],
      dialogVisible: false,
      preview: false,
      previewSvg: '',
      query: '',
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        fileContent: [{ required: true, message: '请上传模板' }]
      },
      form: {
        name: '',
        id: null,
        tagIds: [],
        fileContent: null
      }
    };
  },
  watch: {
    query() {
      this.queryList();
    },
    selection() {
      this.queryList();
    },
    selectionSize() {
      this.queryList();
    },
    dialogVisible(value) {
      if (!value) {
        this.form.name = '';
        this.form.tagIds = [];
        this.form.fileContent = null;
      }
    }
  },
  components: {
    'upload-svg': UploadSvg,
    'category-select': CategorySelect,
    'nav-title': NavTitle,
    'multi-selecter': MultiSelecter,
    'list-row': Row,
    'list-col': Col
  },
  computed: {
    typeTags() {
      return _.filter(this.$store.state.tags.list, function(o) {
        return o.type === 0 && o.name !== '其他';
      });
    },
    sizeTags() {
      return _.filter(this.$store.state.tags.list, function(o) {
        return o.type === 1;
      });
    },
    dimensions() {
      return this.$store.state.tags.dimensions || [];
    }
  },
  beforeDestroy() {
    this.$store.commit('basic/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    hasAuth(val) {
      return hasAuth(val);
    },
    remove(id) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('basic/delete', { id }).then(() => {
            this.refreshData();
          });
        })
        .catch();
    },
    queryList() {
      this.$store.commit('basic/update', {
        condition: {
          name: this.query || undefined,
          tagIds: _.join(_.map(this.selection, 'id'), ',') || undefined,
          tagSizeIds: _.join(_.map(this.selectionSize, 'id'), ',') || undefined
        }
      });
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    showUploadDialog() {
      this.form.name = '';
      this.form.id = null;
      this.form.fileContent = '';
      this.form.tagIds = [];
      this.dialogVisible = true;
    },
    editTemplateMeta(item) {
      this.form.name = item.name;
      this.form.id = item.id;
      this.form.fileContent = item.fileContent;
      this.form.tagIds = item.tag_ids || [];
      this.dialogVisible = true;
    },
    saveTemplateHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$store
            .dispatch('basic/save', {
              ...this.form,
              filePath: convertJSON(this.form.fileContent),
              tagIds: this.form.tagIds.join(',')
            })
            .then(() => {
              this.refreshData();
              this.dialogVisible = false;
              this.$nextTick(() => {
                this.$refs['form'].resetFields();
              });
            });
        }
      });
    },
    previewTemplate(data) {
      this.previewSvg = data.filePath;
      this.preview = true;
    },
    editTemplate(data) {
      this.$router.replace('/works/create/?tpl=' + data.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  margin-bottom: 20px;
  .field {
    margin-right: 8px;
  }
}

.search {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;

  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

.item {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04);
  border: solid 1px #e9edf0;
  .info {
    width: 204px;
    box-sizing: border-box;
    padding: 16px 14px;
    height: 69px;
    display: flex;
    flex-direction: column;
    background: #f4f6f8;
    .name {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.39px;
      color: rgba(0, 0, 0, 0.65);
      white-space: nowrap;
      text-align: left;
      flex: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 20px;
      line-height: 20px;
      display: inline-block;
      padding: 0;
    }
    .size {
      display: inline-block;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.33px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
  .content {
    cursor: pointer;
    width: 204px;
    height: 200px;
    overflow: hidden;
    background: #ffffff;
    justify-content: center;
    display: flex;
    align-items: center;
    > :global(svg) {
      max-width: calc(100% - 28px);
      max-height: calc(100% - 28px);
    }
  }
  .name {
    padding: 5px 0;
    text-align: center;
  }
}
.mask-wrap {
  position: relative;
  .mask-item {
    display: none;
    cursor: pointer;
    width: 100%;
    height: 65px;
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0)
    );
    position: absolute;
    bottom: 0;
    z-index: 2000;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 10px;
    .button {
      color: #fff;
      text-align: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.6);
      display: inline-block;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 7px;
      &:hover {
        background: #3fb7ff;
      }
    }
  }
  &:hover {
    .mask-item {
      display: flex;
    }
  }
}
.template-dialog {
  .divider-line {
    width: 100%;
    height: 1px;
    background: #e9edf0;
    margin-bottom: 14px;
  }
  .template-desc {
    padding-left: 16px;
    margin: 0;
  }
  .template-name-desc {
    font-size: 12px;
    line-height: 17px;
    color: #75808B;
    margin-left: 6px;
  }
  :global(.el-dialog__header) {
    height: 51px;
    background: #f4f6f8;
    padding: 14px 0 15px 23px;
    border-bottom: 1px solid #e9edf0;
  }
  :global(.el-dialog__title) {
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    font-weight: 500;
  }
  :global(.el-dialog__body) {
    padding: 20px 0;
  }
  :global(.el-form-item__label) {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }
}
.preview-dialog {
  .content {
    width: 100%;
    max-height: 500px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    > :global(svg) {
      max-height: 500px;
    }
  }
}
.cl-pagination {
  padding-bottom: 0;
}
</style>
